import React from 'react';
import { FormControlLabel, Checkbox, Typography, Box } from '@mui/material';

interface TCPACheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  dealerName: string;
  error?: boolean;
  disabled?: boolean;
}

const TCPACheckbox: React.FC<TCPACheckboxProps> = ({
  checked,
  onChange,
  dealerName,
  error = false,
  disabled = false,
}) => {
  return (
    <Box>
      <FormControlLabel
        control={
          <Checkbox
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
            disabled={disabled}
            sx={{
              color: error ? 'error.main' : 'primary.main',
              '&.Mui-checked': {
                color: error ? 'error.main' : 'primary.main',
              },
            }}
          />
        }
        label={
          <Typography variant="body2" color={error ? 'error' : 'text.secondary'}>
            I agree to receive text messages and communication from {dealerName}.
          </Typography>
        }
      />
      {error && (
        <Typography variant="caption" color="error" sx={{ ml: 4, display: 'block' }}>
          You must agree to receive messages to continue
        </Typography>
      )}
    </Box>
  );
};

export default TCPACheckbox;
